import React from 'react'

import mutation from './mutation.graphql'

import DeleteEntityModal from 'components/shared/DeleteEntityModal'

export default function DeleteEmergencyContactModal(props) {
  const { emergencyContact } = props

  return (
    <DeleteEntityModal
      entity={emergencyContact}
      modalId={`confirmDeleteEmergencyContact${emergencyContact.id}`}
      fieldGroup='emergencyContacts'
      modalTitle='Delete Emergency Contact?'
      successMessage='Emergency Contact Deleted'
      mutation={mutation}
      mutationName='deleteEmergencyContact'
      {...props}
    />
  )
}
